import React, { Component } from "react";
import { shape, object } from "prop-types";
import Control from "ol/control/Control";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { createSelector } from "reselect";
import { connect } from "react-redux";
import { compose } from "redux";
import { Row, Col } from "react-flexbox-grid";
import { buildArrowItem, getImage } from "./functions";
import _ from "lodash";
import ArrowUp from "@material-ui/icons/ArrowUpward";
import ArrowDown from "@material-ui/icons/ArrowDownward";

const indicatorSelector = state => state.filters.get("disease");
const indicatorsMapSelector = state => state.filters.get("indicators");

const paletteSelector = createSelector(
  indicatorSelector,
  indicatorsMapSelector,
  (indicator, map) => _.get(map, `${indicator}.paletteType`)
);

const styles = theme => ({
  control: {
    zIndex: 1000,
    bottom: "2.5em",
    right: "1em",
    position: "absolute",
    width: 120,
    height: 100
  },
  paper: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: 10,
    paddingRight: 0,
    width: 120
  },
  paperFull: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: 10,
    paddingRight: 0,
    width: 120
  },
  controlFull: {
    zIndex: 1000,
    bottom: "2.5em",
    right: "1em",
    position: "absolute",
    width: 120,
    height: 100
  }
});

function isSecuential(type) {
  return type === "SEQUENTIAL" || type === "INVERTED_SEQUENTIAL";
}

function emptyExtremes(min, max) {
  return min === 0 && max === 0;
}

class PaletteOverlay extends Component {
  state = {
    open: false
  };

  static propTypes = {
    map: shape(),
    classes: object.isRequired
  };

  controlRef = React.createRef();

  componentDidMount() {
    const { map } = this.props;
    const control = new Control({
      element: this.controlRef.current
    });

    map.addControl(control);
  }

  static getDerivedStateFromProps(props, state) {
    const { diseasePalette, minValue, maxValue } = props;
    if (!diseasePalette) {
      return {
        open: false
      };
    } else if (
      isSecuential(diseasePalette) &&
      emptyExtremes(minValue, maxValue)
    ) {
      return {
        open: false
      };
    } else {
      return {
        open: true
      };
    }
  }

  render() {
    const { classes, diseasePalette } = this.props;
    if (!this.state.open) {
      return <div ref={this.controlRef} />;
    } else {
      const { upText, middleText, downText } = buildArrowItem(diseasePalette);
      return (
        <div
          className={this.state.open ? classes.controlFull : classes.control}
          ref={this.controlRef}
        >
          <Paper
            classes={{
              root: this.state.open ? classes.paperFull : classes.paper
            }}
            elevation={1}
          >
            <Row>
              <Col xs={8}>
                <Row style={{ fontSize: 10 }}>
                  <Col xs={12}>{upText}</Col>
                  <Col xs={12}>
                    <ArrowUp />
                  </Col>
                  <Col xs={12}>{middleText}</Col>
                  <Col xs={12}>
                    <ArrowDown />
                  </Col>
                  <Col xs={12}>{downText}</Col>
                </Row>
              </Col>
              <Col xs={4}>{getImage(diseasePalette)}</Col>
            </Row>
          </Paper>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    minValue: state.data.get("minValue"),
    maxValue: state.data.get("maxValue"),
    diseasePalette: paletteSelector(state)
  };
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(PaletteOverlay);



// WEBPACK FOOTER //
// ./src/components/map/paletteOverlay.js